// import logo from './logo.svg';
import './Sass/main.sass'
// import './Sass/includes/Components/modules/countries.sass'
import ModulosPeopleContainer from "./Containers/People/Modules";
function App() {
  return (
    <div className="App">
      <ModulosPeopleContainer/>
      {/* <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header> */}
    </div>
  );
}

export default App;
